import React, { useState, useEffect } from "react";
import "../../styles/MultitessereSezioni.css";

function MultitessereSezioni() {
    const sections = [
        {
            id: "collapseULPS",
            label: "ULPS",
            content:
                <div>
                    <figure className="text-center">
                        <blockquote className="blockquote">
                            <p>
                                <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>ULPS</h1>
                                <br/>
                                <strong>Nuoto libero<br/> + <br/> SPA <br/></strong>
                                <br/>

                            </p>
                        </blockquote>
                    </figure>
                    <table className="table my-table text-center m-auto" style={{width: "20em"}}>
                        <thead >
                        </thead>
                        <tbody>
                        <tr style={{backgroundColor: "#F8F8F8"}}>
                            <th scope="col" style={{width: "50%"}}>3 mesi</th>
                            <td>308 €</td>
                        </tr>
                        <tr>
                            <th scope="row">6 mesi</th>
                            <td>564 €</td>
                        </tr>
                        <tr>
                            <th scope="row">Stagionale</th>
                            <td>755 €</td>
                        </tr>
                        </tbody>
                    </table>
                </div>,
        },
        {
            id: "collapsePLUS",
            label: "PLUS",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>PLUS</h1>
                            <br/>
                            <strong>Palestra<br/> + <br/> SPA <br/></strong>
                            <br/>

                        </p>
                    </blockquote>
                </figure>
                <table className="table my-table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="col" style={{width: "50%"}}>3 mesi</th>
                        <td>299 €</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>545 €</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>762,50 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapseTRIS",
            label: "TRIS",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p className="m-auto">
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>TRIS</h1>
                            <br/>

                            <div className="d-flex flex-wrap justify-content-center">
                                <strong>3 attività a scelta tra:</strong>
                                <ul className="custom-list">
                                    <li>Corsi Acquafitness</li>
                                    <li>Corsi Fitness</li>
                                    <li>Runnering</li>
                                    <li>Palestra</li>
                                </ul>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table my-table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="col" style={{width: "50%"}}>3 mesi</th>
                        <td>359 €</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>638 €</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>815 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapsePOKER",
            label: "POKER",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>POKER</h1>
                            <br/>
                            <strong>Tutti i corsi  di gruppo Fitness di intervallo e sera</strong><br/>
                            <br/>
                        </p>
                    </blockquote>
                </figure>

                <table className="table my-table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="col" style={{width: "10%"}}>1 mese</th>
                        <td>80 €</td>
                    </tr>
                    <tr>
                        <th scope="col" style={{width: "10%"}}>3 mesi</th>
                        <td>216 €</td>
                    </tr>
                    <tr>
                        <th scope="row" style={{width: "10%"}}>6 mesi</th>
                        <td>384 €</td>
                    </tr>
                    <tr>
                        <th scope="col" style={{width: "10%"}}>9 mesi</th>
                        <td>504 €</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>572 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapseSUPER",
            label: "SUPER",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "8em", fontFamily: "Hammersmith One"}}>SUPER</h1>
                            <br/>
                            <div className="d-flex flex-wrap justify-content-center">
                                <strong>1 attività a scelta tra:</strong>
                                <ul className="custom-list">
                                    <li>Corso Acquafitness</li>
                                    <li>Corso Fitness</li>
                                    <li>Runnering</li>
                                    <li>Palestra</li>
                                </ul>
                            </div>
                            <strong>
                                + <br/>
                                Nuoto libero<br/>
                                + <br/>
                                SPA</strong>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table my-table text-center m-auto" style={{width: "40em"}}>
                    <thead >
                    <tr >
                        <th scope="col" ></th>
                        <th scope="col" style={{width: "40%"}}>
                            SUPER Mattino
                            <div style={{fontSize: "11px"}}>(uscita entro le 15)</div>
                        </th>
                        <th scope="col" style={{width: "40%"}}>
                            SUPER
                            <div style={{fontSize: "11px"}}>(orario pieno)</div>
                            <div style={{fontSize: "11px"}}></div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="row">3 mesi</th>
                        <td></td>
                        <td>355 €</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td></td>
                        <td>569 €</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>710 €</td>
                        <td>879 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        },
        {
            id: "collapseWEEKEND",
            label: "WEEKEND",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>WEEKEND</h1>
                            <br/>
                            <strong>Nuoto Libero<br/>
                                + <br/>
                                Palestra<br/>
                                + <br/>
                                SPA</strong>
                            <br/>
                            <div style={{fontSize: "16px"}}>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table my-table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="col" style={{width: "50%"}}>3 mesi</th>
                        <td>175 €</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>280 €</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>470 €</td>
                    </tr>
                    </tbody>
                </table>

            </div>
        },
        {
            id: "collapseOPEN",
            label: "OPEN",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>OPEN</h1>
                            <br/>
                            <strong>Tutto illimitato</strong><br/>
                            <br/>
                            <div style={{fontSize: "16px"}}>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <table className="table my-table text-center m-auto" style={{width: "40em"}}>
                    <thead >
                    <tr >
                        <th scope="col" ></th>
                        <th scope="col" style={{width: "40%"}}>
                            OPEN Mattino
                            <div style={{fontSize: "11px"}}>(uscita entro le 15)</div>
                        </th>
                        <th scope="col" style={{width: "30%"}}>
                            OPEN
                            <div style={{fontSize: "11px"}}>(orario pieno)</div>
                            <div style={{fontSize: "11px"}}></div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td style={{width: "40%"}}>876 €</td>
                        <td style={{width: "40%"}}>1052 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        }
    ];
    const [activePanel, setActivePanel] = useState<string | null>(
        sections.length > 0 ? sections[0].id : null
    );

    const handleButtonClick = (panelId: string) => {
        // Chiudi il pannello attivo se presente
        if (activePanel === panelId) {
            setActivePanel(null);
        } else {
            // Altrimenti, apri il nuovo pannello cliccato
            setActivePanel(panelId);
        }
    };



    return (
        <div className="container-fluid my-container d-flex flex-column m-auto " >
            <div
                className="d-flex flex-wrap p-flex"
                style={{
                    position: "relative",
                    zIndex: 1,
                    marginBottom: 0,
                    marginLeft: "8px",
                }}
            >
                {sections.map((section) => (
                    <button
                        key={section.id}
                        className={`btn btn-outline-secondary my-btn ${activePanel === section.id ? "active" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${section.id}`}
                        aria-expanded={activePanel === section.id ? "true" : "false"}
                        aria-controls={section.id}
                        onClick={() => handleButtonClick(section.id)}
                    >
                        {section.label}
                    </button>
                ))}

            </div>
            <div>
                {sections.map((section) => (
                    <div
                        key={section.id}
                        className={`collapse ${activePanel === section.id ? "show" : ""}`}
                        id={section.id}
                    >
                        <div className="card card-body my-card justify-content-center">{section.content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MultitessereSezioni;
